import { createInjectionState } from '@vueuse/core';
import emblaCarouselVue from 'embla-carousel-vue';
import { onMounted, ref } from 'vue';

const [useProvideCarousel, useInjectCarousel] = createInjectionState(
  ({ opts, orientation, plugins }, emits) => {
    const [emblaNode, emblaApi] = emblaCarouselVue(
      {
        ...opts,
        axis: orientation === 'vertical' ? 'y' : 'x',
      },
      plugins,
    );

    function scrollPrev() {
      emblaApi.value?.scrollPrev();
    }
    function scrollNext() {
      emblaApi.value?.scrollNext();
    }

    const canScrollPrev = ref(false);
    const canScrollNext = ref(false);

    function onSelect(api) {
      canScrollPrev.value = api.canScrollPrev();
      canScrollNext.value = api.canScrollNext();
    }

    onMounted(() => {
      if (!emblaApi.value) {
        return;
      }

      emblaApi.value.on('init', onSelect);
      emblaApi.value.on('reInit', onSelect);
      emblaApi.value.on('select', onSelect);
      onSelect(emblaApi.value);

      emits('init-api', emblaApi.value);
    });

    return {
      carouselRef: emblaNode,
      carouselApi: emblaApi,
      canScrollPrev,
      canScrollNext,
      scrollPrev,
      scrollNext,
      orientation,
    };
  },
);

function useCarousel() {
  const carouselState = useInjectCarousel();

  if (!carouselState) {
    throw new Error('useCarousel must be used within a <Carousel />');
  }

  return carouselState;
}

export { useCarousel, useProvideCarousel };
